import React, { useEffect, useState } from "react";
import { IconButton } from "@mui/material";
import { ReactComponent as DeleteIcon } from "../../../assets/delete.svg";
import { ReactComponent as PlusIcon } from "../../../assets/svg/plusIcon.svg";
import { InputArrayProps } from "./input-array.props";
import InputBox from "src/components/atoms/v2/inputBox/inputBox";

const InputArray: React.FC<InputArrayProps> = ({
	inputString,
	label,
	onChange,
}) => {
	const [inputStrings, setInputStrings] = useState<string[]>(
		inputString ?? [""]
	);

	// Only update the state when `inputString` prop changes
	useEffect(() => {
		if (inputString) {
			setInputStrings(inputString);
		}
	}, [inputString]);

	// Call onChange only when inputStrings actually change
	useEffect(() => {
		if (onChange) {
			onChange(inputStrings);
		}
	}, [inputStrings]); // onChange dependency intentionally omitted to prevent infinite loops

	const handleAddUrl = () => {
		if (inputStrings.length < 3) {
			setInputStrings([...inputStrings, ""]);
		}
	};

	const handleInputChange = (value: string, index: number) => {
		const updatedUrls = [...inputStrings];
		updatedUrls[index] = value;
		setInputStrings(updatedUrls);
	};

	const handleDeleteUrl = (index: number) => {
		setInputStrings(inputStrings.filter((_, i) => i !== index));
	};

	return (
		<div className="flex flex-col items-center justify-center w-full gap-4">
			{inputStrings.map((url, index) => (
				<div
					key={index}
					className="flex items-center justify-center w-full gap-4"
				>
					<InputBox
						label={`${label} ${index + 1}`}
						type={"url"}
						value={url}
						onChange={(value) => handleInputChange(value, index)}
					/>
					<IconButton
						color="error"
						onClick={() => handleDeleteUrl(index)}
						disabled={inputStrings.length === 1}
					>
						<DeleteIcon />
					</IconButton>
				</div>
			))}

			<div className="flex items-center justify-start w-full py-6">
				<button
					onClick={handleAddUrl}
					disabled={inputStrings.length >= 3}
					className={`${
						inputStrings.length >= 3
							? "opacity-50 cursor-not-allowed"
							: ""
					}`}
				>
					<PlusIcon className="w-12 h-12 text-sky-600" />
				</button>
			</div>
		</div>
	);
};

export default InputArray;
